import { useGetCoInvestGpPermissions } from "@vega-api/generated/coinvest-gp-permissions/coinvest-gp-permissions";

import { useCoInvestDealReadOnly } from "./useCoInvestDealReadOnly";

export const useCanEditDealOpportunity = (dealId: string) => {
  const { data: permissions } = useGetCoInvestGpPermissions(
    { dealId },
    { query: { select: (response) => response.data } },
  );
  const { isMutationLocked } = useCoInvestDealReadOnly();

  return {
    canEditDealOpportunity:
      (permissions?.canEditDealOpportunity ?? false) && !isMutationLocked,
    isMutationLocked,
  };
};
